/**
 * 设备工具：移动端展示模式判定
 * =============================================
 * 口径（已确认）：
 * 1. 屏幕分辨率：window.screen.width <= 768（CSS 像素）视为移动端；
 *    用物理屏幕宽度而非视口，避免桌面浏览器拉窄窗口被误判。
 * 2. UA 兜底：Android/iPhone/iPod/Windows Phone/Mobi 等移动标识；
 *    iPadOS 13+ Safari 的 UA 伪装成 Macintosh，需结合 maxTouchPoints 判定。
 */
export function isMobileDevice() {
  if (typeof window === 'undefined') return false
  try {
    const screenNarrow = Boolean(window.screen) && window.screen.width <= 768
    if (screenNarrow) return true

    const ua = String(navigator.userAgent || '')
    const maxTouchPoints = navigator.maxTouchPoints || 0
    const ipadLike =
      /iPad/i.test(ua) || (/Macintosh/i.test(ua) && maxTouchPoints > 1)
    return /Android|iPhone|iPod|Windows Phone|Mobi/i.test(ua) || ipadLike
  } catch (error) {
    console.warn('isMobileDevice check failed:', error)
    return false
  }
}
